import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Form } from 'react-bootstrap';

import { PORTAL_ADMIN, PROJECT_ADMIN } from '../../../store/actions/users/usersActions';
import { handleInputChange, 
  getCostCenter, 
  upsertCostCenter, 
  resetCostCenter } from '../../../store/actions/cost_centers/costCenterActions';

import PageTitle from '../../../common/PageTitle';
import DepartmentField from '../../../common/DepartmentField';

class CostCenterForm extends Component {
  constructor(props) {
    super(props);

    this.submitButtonText = 'Submit';
    this.action = '';

    this.pathname = this.props.location.pathname;
    this.roleId = Cache.getItem('roleId');
  }

  componentDidMount() {
    if (this.roleId === PORTAL_ADMIN || this.roleId === PROJECT_ADMIN) {
      if (this.pathname === '/settings/costcenters/update') {
        const urlParams = new URLSearchParams(this.props.location.search);
        const costCenterId =  urlParams.get('id');
        this.props.getCostCenter(costCenterId);
        this.submitButtonText = 'Update';
        this.action = 'UPDATE_COST_CENTER';
      }
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  componentWillUnmount() {
    this.props.resetCostCenter();
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const submitButton = document.querySelector("button[type='submit']");
    submitButton.disabled = true;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitting...";
    }
    else {
      submitButton.textContent = "Updating...";
    } 
    
    this.props.upsertCostCenter(this.action, () => {
      this.props.history.push('/settings/costcenters');
    })

    submitButton.disabled = false;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitted!";
    }
    else {
      submitButton.textContent = "Updated!";
    }

    setTimeout(() => {  
      submitButton.textContent = this.submitButtonText;
    }, 1000);
  }

  render() {
    let formTitle = '';

    const costCenter = this.props.costCenters.costCenter;
    
    const pathname = this.props.location.pathname;
    
    if (pathname === '/settings/costcenters/update') {
      this.submitButtonText = 'Update';
      formTitle = 'Update Cost Center';
      this.action = 'UPDATE_COST_CENTER';
    }
    else {
      formTitle = 'Create Cost Center';
      this.action = 'ADD_COST_CENTER';
    }

    let costCenterName = '';
    let costCenterCode = '';
    let department = '';

    if (Object.keys(costCenter).length) {
      costCenterName = costCenter.cost_center_name;
      costCenterCode = costCenter.cost_center_code;
      if (typeof(costCenter.department) !== "undefined") {
        department = costCenter.department.id;
      }
    }

    return (
      <>
        <PageTitle pageName={formTitle} />
        <Form className="mt-3" onSubmit={this.handleSubmit}>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="cost_center_code">
                <Form.Label>Cost Center Code <span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="number" 
                  value={costCenterCode}
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="cost_center_name">
                <Form.Label>Cost Center Name <span className='required-field'> * </span></Form.Label>
                <Form.Control 
                  type="text" 
                  value={costCenterName} 
                  onChange={this.props.handleInputChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="department_id">
                <Form.Label>Department <span className='required-field'> * </span></Form.Label>
                <DepartmentField department={department} onChangeCallback={(item) => {
                  this.props.handleInputChange(null, {
                    department: item.value 
                  });
                }}/>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>  
              <div className="float-right">
                <Button variant="default" onClick={() => {
                    this.props.history.push('/settings/costcenters');
                  }}>Cancel</Button> 
                <Button variant="primary" type="submit">{this.submitButtonText}</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export const mapStateToProps = (state) => ({
  costCenters: state.costCenters,
  departments: state.departments 
})

export const mapDispatchToProps = (dispatch) => ({
  handleInputChange: (...args) => dispatch(handleInputChange(...args)),
  getCostCenter: (...args) => dispatch(getCostCenter(...args)),
  upsertCostCenter: (...args) => dispatch(upsertCostCenter(...args)),
  resetCostCenter: () => dispatch(resetCostCenter())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CostCenterForm))
